import { render, staticRenderFns } from "./exhibition-cert-yes.vue?vue&type=template&id=3608ea9d&scoped=true&"
import script from "./exhibition-cert-yes.vue?vue&type=script&lang=js&"
export * from "./exhibition-cert-yes.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-cert-yes.vue?vue&type=style&index=0&id=3608ea9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608ea9d",
  null
  
)

export default component.exports